import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Shown when a member's membership has lapsed (cancelled / payment failed /
// expired). They keep their profile + history; renewing restores access.
// Reached via ProtectedRoute's requireActiveMembership gate.
export default function MembershipRenew() {
  const { userProfile } = useAuth();
  const ms = userProfile?.membershipStatus;

  const reason =
    ms === 'payment_failed'
      ? 'Your most recent membership payment didn’t go through, so your member access is paused.'
      : ms === 'cancelled'
      ? 'Your membership has been cancelled, so your member access is paused.'
      : 'Your membership is no longer active, so your member access is paused.';

  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center">
      <img
        src={`${process.env.PUBLIC_URL}/apn-logos/APN-blue (1).png`}
        alt="APN"
        className="h-16 mx-auto mb-6 object-contain"
      />
      <h1 className="text-3xl font-bold text-gray-900 mb-4">Renew Your APN Membership</h1>
      <p className="text-gray-600 mb-2">{reason}</p>
      <p className="text-gray-600 mb-8">
        Renew now to restore access to the member directory, groups, and the job &amp; project boards.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link
          to="/register"
          className="bg-apn-blue text-white py-3 px-8 rounded-lg font-semibold hover:bg-blue-700 transition duration-200"
        >
          Renew Membership
        </Link>
        <a
          href="mailto:cburnham@the-apn.com?subject=APN%20Membership%20Renewal"
          className="border border-gray-300 text-gray-700 py-3 px-8 rounded-lg font-semibold hover:bg-gray-50 transition duration-200"
        >
          Contact APN
        </a>
      </div>
      <p className="text-sm text-gray-400 mt-8">
        Your profile and history are preserved — renewing simply restores your access.
      </p>
    </div>
  );
}
